import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Metode de plată',
  payment_options: {
    [PaymentMethod.Card]: 'Card de credit',
  },
};
